export default __webpack_public_path__ + "static/media/Supplier_Product_Promotion_2711_1012_2025.141500f7.xlsx";